import PropTypes from 'prop-types';
import ErrorBoundary from './ErrorBoundary';
import BackButton from './BackButton';
import ScrollableWrapper from './ScrollableWrapper';

export default function DesktopView({
  title,
  header,
  map,
  content,
  settingsDrawer,
  scrollable = false,
  bckBtnVisible = true,
  bckBtnFallback,
}) {
  return (
    <div className="desktop">
      <div className="main-content" role="main" id="main-content">
        {bckBtnVisible && (
          <div className="desktop-title h1">
            <BackButton title={title} fallback={bckBtnFallback} />
          </div>
        )}
        <ScrollableWrapper scrollable={scrollable}>
          {header}
          <ErrorBoundary>{content}</ErrorBoundary>
        </ScrollableWrapper>
      </div>
      <div className="map-content">
        {settingsDrawer}
        {map && <ErrorBoundary>{map}</ErrorBoundary>}
      </div>
    </div>
  );
}

DesktopView.propTypes = {
  title: PropTypes.node,
  header: PropTypes.node,
  map: PropTypes.node,
  content: PropTypes.node,
  settingsDrawer: PropTypes.node,
  scrollable: PropTypes.bool,
  bckBtnVisible: PropTypes.bool,
  bckBtnFallback: PropTypes.string,
};
